export const targetParentMap = new WeakMap()

export function findRootTarget(target) {
    if (!target) return null
    const seen = new Set()
    while (
        targetParentMap.get(target) &&
        (!Object.isEmpty(targetParentMap.get(target)) ||
            !Object.values(targetParentMap.get(target)).some((v) => v === target))
    ) {
        if (seen.has(target)) break
        seen.add(target)
        target = targetParentMap.get(target)
    }
    return target
}

export function discoverPropertyPath(fieldName, currentValue, target) {
    // fieldName = "name"
    // currentValue = "Test"
    // target = { name: "Test" }

    // fieldName = "something.otherthing.1.somethingelse.name"
    const fieldNameParts = fieldName?.split(".")
    const root = findRootTarget(target)
    return scan(root)
    function scan(node, path = [], parentContext = root, ok = false, innerKey) {
        if ((ok || parentContext === target) && (innerKey === fieldName || (ok && innerKey === fieldNameParts.at(-1))))
            return path.join(".")

        if (Array.isArray(node)) {
            for (let i = 0; i < node.length; i++) {
                // noinspection EqualityComparisonWithCoercionJS

                const result = scan(node[i], [...path, i], node, ok, i)
                if (result) return result
            }
        } else if (typeof node === "object" && !!node) {
            for (const [key, value] of Object.entries(node)) {
                ok ||= key === fieldNameParts[0] && node === target

                const result = scan(value, [...path, key], node, ok, key)
                if (result) return result
            }
        }
        return null
    }
}
